import React, { Component } from 'react';
import Widget from '../Widget';

class ChatContainer extends Component {

// componentDidMount()
  render = () => {
      return (
        <div className="chat-container">
          <Widget />
        </div >
      );
  }
// constructor(props) { super(props); }
// componentWillMount() {}
// componentWillReceiveProps(){}
// shouldComponentUpdate(){}
// componentWillUpdate(){}
// componentDidUpdate(){}
// componentWillUnmount(){}

}
export default ChatContainer;